import React, { useState } from 'react';
import '../styles/organisms/agency_registration_application_attention.scss';
import { ZENDESK_URL_GUIDE } from '../utilities/constants';

export const DISPLAY_MODE = {
  AgencyCompanies: 1,
  AgencyRegistrationApplications: 2,
};

const PageHeaderCloseBtn = props => {
  const { onClose, className = 'PageHeaderCloseBtn', displayMessage } = props;

  return (
    <button onClick={onClose} className={className} style={{ margin: 0 }}>
      {displayMessage ? (
        <React.Fragment>
          <span className='PageHeaderCloseBtn__close-text'>閉じる</span>
          <div className='PageHeaderCloseBtn__button-icon'>
            <i className='i-close__header i-2_4x' />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <span className='PageHeaderCloseBtn__close-text'>開く</span>
          <div className='PageHeaderCloseBtn__button-icon PageHeaderCloseBtn__button-icon--open'>
            <i className='i-close__header i-2_4x' />
          </div>
        </React.Fragment>
      )}
    </button>
  );
};

const AgencyRegistrationApplicationAttention = ({ displayMode }) => {
  const [displayMessage, toggleDisplayMessage] = useState(true);

  switch (displayMode) {
    case DISPLAY_MODE.AgencyCompanies:
      return (
        <div className='AgencyRegistrationApplicationAttention'>
          代行登録機能を利用することで、下位協力会社の会社情報や作業員情報を登録/編集できます。
          <br />
          下位協力会社を代行するには「代行登録申請」画面から申請が必要です。代行登録の詳細は
          <a
            className='clickable-text'
            href={ZENDESK_URL_GUIDE.AGENCY_REGISTRATION}
            target='_blank'
            rel='noreferrer noopener'
          >
            こちら
          </a>
          をご確認ください。
          <br />
          代行登録操作を行えるのは、代行担当者に設定された協力会社管理者ユーザーのみとなります。
        </div>
      );
    case DISPLAY_MODE.AgencyRegistrationApplications:
      return (
        <div className='AgencyRegistrationApplicationAttention'>
          <div className='AgencyRegistrationApplicationAttention__title-box'>
            <h2 className='AgencyRegistrationApplicationAttention__title'>
              代行登録について
            </h2>
            <PageHeaderCloseBtn
              className={'PageHeaderCloseBtn PageHeaderCloseBtn--white'}
              onClose={() => toggleDisplayMessage(!displayMessage)}
              displayMessage={displayMessage}
            />
          </div>
          {displayMessage && (
            <React.Fragment>
              <div className='AgencyRegistrationApplicationAttention__item'>
                <div className='AgencyRegistrationApplicationAttention__item-decription'>
                  両社間で締結した覚書を添付し代行登録申請を行うことで下位協力会社の会社情報や作業員情報を代わりに登録できます。
                  <br />
                  <div>
                    代行登録の概要については
                    <a
                      className='clickable-text'
                      href={ZENDESK_URL_GUIDE.AGENCY_REGISTRATION}
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      こちら
                    </a>
                    をご確認ください。
                  </div>
                  <div>
                    覚書の記載方法については
                    <a
                      className='clickable-text'
                      href={ZENDESK_URL_GUIDE.MEMORANDUM_GUIDE}
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      こちら
                    </a>
                    をご確認ください。
                  </div>
                  <div className='AgencyRegistrationApplicationAttention__item-decription-title'>
                    テンプレートは常に最新版をダウンロードのうえご利用ください。
                  </div>
                  <ul className='AgencyRegistrationApplicationAttention__item-decription-list'>
                    <li className='AgencyRegistrationApplicationAttention__item-decription-list-item'>
                      現在の最新テンプレート：2022年04月01日更新（タイトルに「代行登録に関する覚書」と記載）
                    </li>
                    <li className='AgencyRegistrationApplicationAttention__item-decription-list-item'>
                      旧テンプレートの有効期限：2022年06月30日まで
                      <ul>
                        <li className='AgencyRegistrationApplicationAttention__item-decription-list-item AgencyRegistrationApplicationAttention__item-decription-list-item--attention'>
                          ※フッターにOBG-001の記載がないテンプレートは、2022年07月01日以降はご利用いただけません。
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      );
    default:
      return null;
  }
};

export default AgencyRegistrationApplicationAttention;



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationAttention.jsx